export default __webpack_public_path__ + "static/media/career-year.3b7ec3f5.png";